// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__uvq3e","wrapper__title":"Card_wrapper__title__0aeO+"};